(function(angular) {
    'use strict';

    
    angular.module('GorillaBoy.services')
    .factory('WopiService', [
        '$rootScope',
        '$http',
        '$log',
        '$q',
        'authenticatedUser',
        'EndpointService',
        'AppConstants',
        'SourceConstant',
        WopiService
    ]);

    function WopiService($rootScope, $http, $log, $q, authenticatedUser, EndpointService, AppConstants, SourceConstant) {
        var wopiService = {},
            languageToLocaleIdMap = getLanguageForLocaleId();

        function SERVICE_ROOT() {
            return EndpointService.wopiEndpoint();
        }


        wopiService.getActionUrl = function(documentType, operationType, language, sessionId) {
            var config =  { 
                'headers': {
                    'documentType' : documentType,
                    'operationType' : operationType,
                    'languageId' : getLanguageId(language),
                    'sessionId' :  sessionId
                }
            },
            serviceUrl = SERVICE_ROOT() + '/actionUrl';


            return $http.get(serviceUrl, config); 
        };

        wopiService.getAccessToken = function(userId, documentId, versionId, accessToken, accessTokenExpiryTime, siteDomain){
            var config = {
                'headers': {
                    'userId' : userId,
                    'documentId' : documentId,
                    'versionId' : versionId,
                    'accessToken' : accessToken,
                    'accessTokenExpiryTime' : accessTokenExpiryTime,
                    'siteDomain': siteDomain
                }
            },

            serviceUrl = SERVICE_ROOT() + '/accessToken';

            return $http.get(serviceUrl, config);
        };

        wopiService.getFileEndpointUrl = function(documentId){
            var rawUrl = SERVICE_ROOT() + '/wopi/files/' + documentId;
            return encodeURIComponent(rawUrl);
        };

        function getLanguageId(language){
            var localeId = languageToLocaleIdMap.en,
                mappedValue = languageToLocaleIdMap[language] ;

            if(mappedValue){
                localeId = mappedValue;
            }

            return localeId;
        }

        // The map contents were populated by consulting the following pages: 
        // 1. https://msdn.microsoft.com/en-us/library/ms533052(v=vs.85).aspx
        // 2. https://msdn.microsoft.com/en-us/library/ms912047(v=winembedded.10).aspx
        function getLanguageForLocaleId(){
            var map = {};

            map.en       = "en-US";
            map.de       = "de-DE";
            map.es       = "es-ES";
            map.fr       = "fr-FR";
            map.ja       = "ja-JP";
            map.ko       = "ko-KR";
            map['pt-br']    = "pt-BR";
            map['zh-cn']    = "zh-CN";

            return map;
        }
        
        return wopiService;
    }
}(angular));
